(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["giftiliya-delivery-checker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('giftiliya-delivery')) {
    customElements.define('giftiliya-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.input = this.querySelector('input');
        this.button = this.querySelector('button');
        this.status = this.querySelector('.gd-status');
        this.results = this.querySelector('.gd-results');
        this.button.addEventListener('click', () => this.check());
        this.input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.check(); } });
        this.input.addEventListener('input', () => { this.controller?.abort(); this.results.hidden = true; this.status.textContent = ''; this.input.removeAttribute('aria-invalid'); });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async check() {
        this.controller?.abort();
        this.results.hidden = true;
        const pin = this.input.value.trim();
        if (!/^[1-9]\d{5}$/.test(pin)) { this.status.textContent = this.dataset.invalid; this.input.setAttribute('aria-invalid','true'); this.input.focus(); return; }
        this.input.removeAttribute('aria-invalid');
        if (!this.dataset.endpoint || !this.dataset.endpoint.startsWith('/apps/')) { this.status.textContent = this.dataset.preview; return; }
        const controller = new AbortController();
        this.controller = controller;
        const timer = setTimeout(() => controller.abort('timeout'), 12000);
        this.button.disabled = true;
        this.setAttribute('aria-busy','true');
        this.status.textContent = this.dataset.loading;
        try {
          const productInfo = this.closest('product-info');
          const variant = productInfo?.querySelector('form[action*="/cart/add"] [name="id"]')?.value || this.dataset.variant;
          const url = new URL(this.dataset.endpoint, location.origin);
          url.searchParams.set('pincode',pin);
          url.searchParams.set('product_id',this.dataset.product);
          url.searchParams.set('variant_id',variant);
          const response = await fetch(url, {signal:controller.signal,headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('unavailable');
          const data = await response.json();
          if (this.controller !== controller || this.input.value.trim() !== pin) return;
          const format = value => {
            if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return this.dataset.unavailable;
            const date = new Date(value+'T12:00:00+05:30');
            if (!Number.isFinite(date.getTime()) || date.getTime() < Date.now()-86400000) return this.dataset.unavailable;
            return date.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short',timeZone:'Asia/Kolkata'});
          };
          this.querySelector('[data-normal]').textContent = format(data.normal?.delivery_date);
          this.querySelector('[data-fast]').textContent = format(data.fast?.delivery_date);
          this.status.textContent = '';
          this.results.hidden = false;
        } catch (error) {
          if (this.controller === controller && (!controller.signal.aborted || controller.signal.reason === 'timeout')) this.status.textContent = this.dataset.error;
        } finally {
          clearTimeout(timer);
          if (this.controller === controller) { this.button.disabled = false; this.removeAttribute('aria-busy'); }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["giftiliya-order-journey"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('giftiliya-journey')){customElements.define('giftiliya-journey',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.timers=[];const steps=Array.from(this.querySelectorAll('.gjw-step'));this.reduce=matchMedia('(prefers-reduced-motion: reduce)');const play=()=>{this.timers.forEach(clearTimeout);steps.forEach(s=>s.classList.remove('is-active','is-past'));if(this.reduce.matches){steps.forEach(s=>s.classList.add('is-past'));return;}steps.forEach((step,index)=>this.timers.push(setTimeout(()=>{steps.forEach((s,i)=>{s.classList.toggle('is-active',i===index);s.classList.toggle('is-past',i<index);});},300+index*1800)));this.timers.push(setTimeout(()=>steps.forEach(s=>{s.classList.remove('is-active');s.classList.add('is-past');}),7800));};this.onMotion=play;this.reduce.addEventListener('change',play);this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){play();this.observer.disconnect();}},{threshold:.3});this.observer.observe(this);}disconnectedCallback(){this.timers?.forEach(clearTimeout);this.observer?.disconnect();this.reduce?.removeEventListener('change',this.onMotion);this.ready=false;}});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["giftiliya-promise"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    document.querySelectorAll('.giftiliya-promise:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      if (!('IntersectionObserver' in window)) { root.classList.add('is-visible'); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { root.classList.add('is-visible'); observer.disconnect(); }
      }, { threshold: 0.15 });
      observer.observe(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["giftiliya-trust"] && !Shopify.designMode) return;
  try {
    (()=>{const init=(root=document)=>{root.querySelectorAll('.gft:not([data-gft-init])').forEach(el=>{el.dataset.gftInit='true';if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){el.classList.add('gft-ready');observer.disconnect()}},{threshold:.15});observer.observe(el);document.addEventListener('shopify:section:unload',function cleanup(event){if(event.target.contains(el)){observer.disconnect();document.removeEventListener('shopify:section:unload',cleanup)}})})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();document.addEventListener('shopify:section:load',event=>init(event.target))})();
  } catch(e) { console.error(e); }
})();

})();
